module.exports = __webpack_public_path__ + "img/v3.aafa4ad0.png";